<template>
  <div class="l-navbar" id="nav-bar">
    <div
      v-if="logged != ''"
      class="d-flex align-items-center justify-content-start mb-4 gap-2"
    >
      <p
        v-if="profile?.avatar == null"
        class="avatar-m square m-0 d-flex align-items-center justify-content-center"
      >
        {{ initials(profile?.fullname) }}
      </p>
      <img
        v-else
        :src="profile?.avatar"
        :alt="profile?.fullname"
        class="avatar-m square"
      />

      <div class="text-start overflow-hidden">
        <p class="m-0 navy-text fw-semibold">{{ profile?.fullname }}</p>
        <p class="m-0 sub sub-text truncate" style="--max-lines: 1">
          {{ profile?.email }}
        </p>
      </div>
    </div>
    <div class="l-navbar-content">
      <div v-if="logged == ''">
        <router-link
          :to="{ name: 'course' }"
          class="side-link text-decoration-none"
          @click="toggleSideBar"
          >Program Dilatih</router-link
        >
        <router-link
          :to="{ name: 'partnership' }"
          class="side-link text-decoration-none"
          @click="toggleSideBar"
          >Untuk Perusahaan</router-link
        >
        <router-link
          :to="{ name: 'about-us' }"
          class="side-link text-decoration-none"
          @click="toggleSideBar"
          >Tentang Kami</router-link
        >
      </div>
      <div v-else>
        <div v-if="role == 2">
          <button
            v-if="asPeserta"
            class="side-link text-decoration-none view-switch"
            @click="backToAdmin"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/dashboard.svg')"
                alt=""
                srcset="" /></span
            >Kembali ke Admin
          </button>
          <router-link
            :to="{ name: 'dashboard' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/dashboard.png')"
                alt=""
                srcset="" /></span
            >Dashboard</router-link
          >
          <router-link
            :to="{ name: 'user-dilatih-insight' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/insight.png')"
                alt=""
                srcset="" /></span
            >Dilatih Insight</router-link
          >
          <router-link
            :to="{ name: 'user-dilatih-workshop' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/workshop.png')"
                alt=""
                srcset="" /></span
            >Dilatih Workshop</router-link
          >
          <router-link
            :to="{ name: 'certificate' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/certificate.png')"
                alt=""
                srcset="" /></span
            >Sertifikat</router-link
          >
          <router-link
            :to="{ name: 'transaction' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/transaction.png')"
                alt=""
                srcset="" /></span
            >Daftar Transaksi</router-link
          >
          <router-link
            :to="{ name: 'profile-pengguna' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/profile-user.png')"
                alt=""
                srcset="" /></span
            >Profile</router-link
          >
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
        </div>
        <div v-if="role == 6">
          <router-link
            :to="{ name: 'trainer-dashboard' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/dashboard.svg')"
                alt=""
                srcset="" /></span
            >Dashboard</router-link
          >
          <!-- <router-link :to="{ name: 'trainer-schedule' }" class="side-link text-decoration-none" @click="toggleSideBar"><span class="icon-dash"><img :src="require('@/assets/images/cms/schedule.png')"
                alt="" srcset="" /></span>Jadwal</router-link> -->
          <!-- <router-link
            :to="{ name: 'trainer-portal' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><school-outline-icon class="m3-icon-m" /></span
            >Portal Penilaian</router-link
          > -->
          <router-link
            :to="{ name: 'trainer-event' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/event.png')"
                alt=""
                srcset="" /></span
            >Daftar Event</router-link
          >
          <router-link :to="{ name: 'trainer-payment' }" class="side-link text-decoration-none" @click="toggleSideBar"><span class="icon-dash"><img
                :src="require('@/assets/images/cms/Payment.png')" alt="" srcset="" /></span>Payment & Report</router-link>
         
          <router-link
            :to="{ name: 'trainer-profile' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/profile.png')"
                alt=""
                srcset="" /></span
            >Profile</router-link
          >
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
        </div>

        <div v-if="role == 3">
          <router-link
            :to="{ name: 'affiliate-dashboard' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/dashboard.svg')"
                alt=""
                srcset="" /></span
            >Dashboard</router-link
          >
          <router-link
            :to="{ name: 'affiliate-product' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/product.png')"
                alt=""
                srcset="" /></span
            >Produk</router-link
          >
          <router-link
            :to="{ name: 'affiliate-transaction' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/transaction.png')"
                alt=""
                srcset="" /></span
            >Transaksi</router-link
          >
          <router-link
            :to="{ name: 'affiliate-payment' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/Payment.png')"
                alt=""
                srcset="" /></span
            >Pembayaran</router-link
          >
          <router-link
            :to="{ name: 'affiliate-profile' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/profile.png')"
                alt=""
                srcset="" /></span
            >Profile</router-link
          >
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
        </div>
        <div v-if="role == 1">
          <router-link
            :to="{ name: 'admin-dashboard' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/dashboard.svg')"
                alt=""
                srcset="" /></span
            >Dashboard</router-link
          >
          <router-link
            :to="{ name: 'admin-landing-page' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/cms.svg')"
                alt=""
                srcset="" /></span
            >CMS Landing Page</router-link
          >
          <router-link
            :to="{ name: 'admin-partnership' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/partner.svg')"
                alt=""
                srcset="" /></span
            >Dilatih partnership</router-link
          >
          <router-link
            :to="{ name: 'admin-insight' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/insight.svg')"
                alt=""
                srcset="" /></span
            >Dilatih Insight</router-link
          >
          <router-link
            :to="{ name: 'admin-workshop' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/workshop.svg')"
                alt=""
                srcset="" /></span
            >Dilatih Workshop</router-link
          >
          <router-link
            :to="{ name: 'admin-class' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/class.svg')"
                alt=""
                srcset="" /></span
            >Dilatih Class</router-link
          >
          <router-link
            :to="{ name: 'admin-blog' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/insight.svg')"
                alt=""
                srcset="" /></span
            >Dilatih Blog</router-link
          >
          <router-link
            :to="{ name: 'admin-management' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/user.svg')"
                alt=""
                srcset="" /></span
            >User Management</router-link
          >
          <router-link
            :to="{ name: 'admin-affiliate' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/referral.svg')"
                alt=""
                srcset="" /></span
            >Affiliate</router-link
          >
          <router-link
            :to="{ name: 'admin-payment' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/payment.svg')"
                alt=""
                srcset="" /></span
            >Payment & Report</router-link
          >
          <router-link
            :to="{ name: 'admin-settings' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/settings.svg')"
                alt=""
                srcset="" /></span
            >System Settings</router-link
          >
          <SsoApps />
          <button
            class="side-link text-decoration-none view-switch"
            @click="viewAsPeserta"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/user.svg')"
                alt=""
                srcset="" /></span
            >Lihat sebagai Peserta
          </button>
          <router-link
            :to="{ name: 'admin-leads' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/insight.svg')"
                alt=""
                srcset="" /></span
            >Sales Leads / BI</router-link
          >
          <router-link
            :to="{ name: 'admin-pmli' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/partner.svg')"
                alt=""
                srcset="" /></span
            >Integrasi PMLI</router-link
          >
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
          <!-- <router-link :to="{ name: 'admin-notif' }" class="side-link text-decoration-none" @click="toggleSideBar"><span class="icon-dash"><img
                                                :src="require('@/assets/images/cms/newsletter.svg')" alt="" srcset="" /></span>Newsletter</router-link> -->
          <!-- <router-link :to="{ name: 'admin-backup' }" class="side-link text-decoration-none" @click="toggleSideBar"><span class="icon-dash"><img
                                                :src="require('@/assets/images/cms/backup.svg')" alt="" srcset="" /></span>Backup</router-link> -->
        </div>

        <div v-if="role == 7">
          <SsoApps />
          <button
            class="side-link text-decoration-none view-switch"
            @click="viewAsPeserta"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/user.svg')"
                alt=""
                srcset="" /></span
            >Lihat sebagai Peserta
          </button>
          <router-link
            :to="{ name: 'admin-leads' }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/insight.svg')"
                alt=""
                srcset="" /></span
            >Sales Leads / BI</router-link
          >
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
        </div>

        <!-- menu-driven roles (Operasional, Helpdesk, and any custom role created
             via User Management > add_akses): render whatever tabs hak_akses grants -->
        <div v-if="isMenuRole">
          <router-link
            v-for="(item, index) in menu"
            :key="index"
            :to="{ name: item.link }"
            class="side-link text-decoration-none"
            @click="toggleSideBar"
            ><span class="icon-dash"
              ><img :src="item.icon" :alt="item.menu" srcset="" /></span
            >{{ item.menu }}</router-link
          >
          <SsoApps />
          <button
            class="side-link text-decoration-none view-switch"
            @click="viewAsPeserta"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/cms/user.svg')"
                alt=""
                srcset="" /></span
            >Lihat sebagai Peserta
          </button>
          <button
            class="side-link text-decoration-none sign-out"
            @click="logout()"
          >
            <span class="icon-dash"
              ><img
                :src="require('@/assets/images/admin/sign-out.png')"
                alt=""
                srcset="" /></span
            >Keluar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import { useToast } from 'vue-toastification'
import { useLoading } from 'vue-loading-overlay'
import { useRouter } from 'vue-router'
import SsoApps from '@/components/admin/SsoApps.vue'
import { effectiveRole, setViewAsPeserta, viewingAsPeserta } from '@/utils/viewMode'

export default {
  name: 'SidebarAdminComponent',
  components: { SsoApps },
  setup() {
    const router = useRouter()
    const toast = useToast()
    const store = useStore()
    const $loading = useLoading({})
    const route = useRoute()
    const data = reactive({
      route: '',
      isLogin: false,
    })

    const profile = computed(() => {
      return JSON.parse(window.localStorage.getItem('user'))
    })

    const logged = computed(() => {
      return window.localStorage.getItem('token')
    })

    const menu = computed(() => {
      return JSON.parse(window.localStorage.getItem('menu'))
    })

    // roles whose sidebar comes from hak_akses (menu table) rather than a
    // hardcoded block: anything outside the fixed roles 1/2/3/6/7
    // The role this sidebar renders for: 2 while a staff member views the site as a peserta.
    const role = computed(() => effectiveRole(profile.value))
    const asPeserta = computed(() => viewingAsPeserta(profile.value))

    function viewAsPeserta() {
      setViewAsPeserta(true)
      window.location.href = router.resolve({ name: 'dashboard' }).href
    }

    function backToAdmin() {
      setViewAsPeserta(false)
      const own = Number(profile.value?.id_role)
      let target = { name: 'admin-dashboard' }
      if (own === 7) target = { name: 'admin-leads' }
      else if (own !== 1 && Array.isArray(menu.value) && menu.value.length) target = { name: menu.value[0].link }
      window.location.href = router.resolve(target).href
    }

    const isMenuRole = computed(() => {
      const role = effectiveRole(profile.value)
      return (
        !!role &&
        ![1, 2, 3, 6, 7].includes(role) &&
        Array.isArray(menu.value) &&
        menu.value.length > 0
      )
    })

    const ip = computed(() => {
      return window.localStorage.getItem('ip')
    })

    function toggleSideBar() {
      let toggler = document.querySelector('.sidebar-toggler')
      let nav = document.querySelector('.l-navbar')
      nav.classList.toggle('show')
      if (nav.className.includes('show')) {
        toggler.classList.add('sidebar-open')
      } else {
        toggler.classList.remove('sidebar-open')
      }
    }

    function logout() {
      setViewAsPeserta(false)
      toggleSideBar()
      Swal.fire({
        icon: 'info',
        title: 'apa anda yakin ingin keluar ?',
        showDenyButton: true,
        confirmButtonText: 'Ya, saya yakin',
        denyButtonText: `Batalkan`,
      }).then((result) => {
        const loader = $loading.show()
        if (result.isConfirmed) {
          let ip_address = ip.value
          store
            .dispatch('auth/logout', {
              ip_address,
            })
            .then(() => {
              toast.success('berhasil logout!')
              loader.hide()
              router.push({ name: 'login' })
              return
            })
            .catch(() => {
              toast.error('internal server error!')
              loader.hide()
              return
            })
        } else if (result.isDenied) {
          loader.hide()
          // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }

    onMounted(() => {
      data.route = route.name
    })

    return {
      role,
      asPeserta,
      viewAsPeserta,
      backToAdmin,
      logout,
      toggleSideBar,
      data,
      menu,
      profile,
      logged,
      isMenuRole,
    }
  },
}
</script>

<style scoped>
.view-switch {
  background: none;
}
</style>
